export enum AssessmentMetricType {
    'SPEED' = 'SPEED',
    'DISTANCE' = 'DISTANCE',
    'TIME' = 'TIME',
    'REPS' = 'REPS',
}
